const PATH = 'app/Notification';

export const LOAD_NOTIFICATION_LIST_REQUEST = `${PATH}LOAD_NOTIFICATION_LIST_REQUEST`;
export const LOAD_NOTIFICATION_LIST_ERROR = `${PATH}LOAD_NOTIFICATION_LIST_ERROR`;
export const LOAD_NOTIFICATION_LIST_LOADING = `${PATH}LOAD_NOTIFICATION_LIST_LOADING`;
export const LOAD_NOTIFICATION_LIST_SUCCESS = `${PATH}LOAD_NOTIFICATION_LIST_SUCCESS`;
export const LOAD_SMS_NOTIFICATION_LIST_REQUEST = `${PATH}LOAD_SMS_NOTIFICATION_LIST_REQUEST`;
export const LOAD_SMS_NOTIFICATION_LIST_ERROR = `${PATH}LOAD_SMS_NOTIFICATION_LIST_ERROR`;
export const LOAD_SMS_NOTIFICATION_LIST_LOADING = `${PATH}LOAD_SMS_NOTIFICATION_LIST_LOADING`;
export const LOAD_SMS_NOTIFICATION_LIST_SUCCESS = `${PATH}LOAD_SMS_NOTIFICATION_LIST_SUCCESS`;